module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_9016.e4107b03.png";